// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedAddressView_container__E3Ewc","title":"SelectedAddressView_title__KdG1H","bodyText":"SelectedAddressView_bodyText__AbWIS"};